import { Form, Input, Row, Col, Switch, Select } from 'antd';
import { useEffect, useRef, useState, } from 'react';
import AntDraggableModal from '../../../../utils/extend/AntDraggableModal';
import WebEditUniversal, { WEUExtendPropsType } from '../../../system/WebEditUniversalNewEx';
import getList from '../../../../utilsTsx/universal/getList';
import fetchApi from '../../../../utils/api/fetchApi';
import { Methods } from '../../../../utilsTs/declareTypes';

//布局
const layout = {
    // labelCol: { span: 8 },
    // wrapperCol: { span: 16 }, 
};

const WebEdit = (props: any) => {
    const [form] = Form.useForm(); //form 
    const { data } = props;
    const ref = useRef<any>(undefined);
    const [wxAccountWxMiniApp, setWxAccountWxMiniApp] = useState<any>();
    const [wxMiniAppEnvVersion, setWxMiniAppEnvVersion] = useState<any>();
    const [remotePushTypeData, setRemotePushTypeData] = useState<any>();
    /** 后端数据defaultService */
    let defaultService: any = '';

    useEffect(() => {
        if (ref.current) {
            // eslint-disable-next-line react-hooks/exhaustive-deps
            defaultService = ref.current.defaultService;
        }
        const fetchData = async () => {
            fetchApi.GET(defaultService, {
                apiId: "generalData",
                apiExtend: 'wxAccountList',
                apiData: {
                    slectType: 'wxMiniApp'
                }
            }).then(res => {
                if (res.success === true) {
                    setWxAccountWxMiniApp(res.data);
                }
            })
            fetchApi.GET(defaultService, {
                apiId: "generalData",
                apiVariable: 'wxMiniAppEnvVersion@remotePushType',
                apiExtend: 'showLists',
            }).then(res => {
                if (res.success === true) {
                    const { wxMiniAppEnvVersion, remotePushType } = res.data;
                    setWxMiniAppEnvVersion(wxMiniAppEnvVersion);
                    setRemotePushTypeData(remotePushType);
                }
            })
        };
        fetchData();
    }, []);

    const handleOk = (e: any) => {
        ref.current.handleOk();
    };
    const handleCancel = (e: any) => {
        ref.current.handleCancel();
    };

    let extendProps: WEUExtendPropsType = {
        ...props,
        form,
        apiId: 'customerServiceOperator',
        serviceId: 'business'
    };

    return (
        <><WebEditUniversal ref={ref} props={extendProps} />
            <AntDraggableModal
                title={(data.type === 'NEW' ? '新增' : '编辑') + '客服使用者'}
                open={true}
                okText='确定'
                cancelText='取消'
                onOk={handleOk}
                onCancel={handleCancel}
                closable={false}
                maskClosable={false}
                width={800}>

                <Form
                    {...layout}
                    form={form}
                    name="Edit"
                    onFinish={handleOk}
                // onKeyPress={(e: any) => {
                //     if (e.key === 'Enter') {
                //         handleOk(e)
                //     }
                // }}
                >
                    <Row gutter={[8, 0]}>
                        <Col span={24}>
                            <Form.Item
                                label="id"
                                name="id">
                                <Input disabled={true} />
                            </Form.Item>
                        </Col>

                        <Col span={12}>
                            <Form.Item
                                label="使用者id"
                                name="operatorId"
                                tooltip='使用者id，例如：店铺id'
                                rules={[{ required: true, message: '使用者id!' }]}>
                                <Input />
                            </Form.Item>
                        </Col>

                        <Col span={12}>
                            <Form.Item
                                label="名称"
                                name="operatorName">
                                <Input />
                            </Form.Item>
                        </Col>

                        <Col span={8}>
                            <Form.Item
                                label="方法"
                                name="methodId">
                                <Select
                                    showSearch
                                    placeholder="方法"
                                    optionFilterProp="children"
                                    filterOption={(input, option: any) =>
                                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
                                    {getList.general(Methods.getAll())}
                                </Select>
                            </Form.Item>
                        </Col>

                        <Col span={16}>
                            <Form.Item
                                label="地址"
                                name="pushAddress"
                                tooltip='推送地址，例如：(推送): https://wms.wisca.cn/test/wm/service  (转发): https://bms.wisca.cn/test'
                                rules={[{ required: true, message: '推送地址!' }]}>
                                <Input />
                            </Form.Item>
                        </Col>

                        <Col span={11}>
                            <Form.Item
                                label="微信小程序"
                                name="wxAccountId">
                                <Select
                                    showSearch
                                    placeholder="微信小程序"
                                    optionFilterProp="children"
                                    filterOption={(input, option: any) =>
                                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
                                    {getList.general(wxAccountWxMiniApp)}
                                </Select>
                            </Form.Item>
                        </Col>

                        <Col span={6}>
                            <Form.Item
                                label="版本"
                                name="wxMiniAppEnvVersionId">
                                <Select
                                    showSearch
                                    placeholder="微信小程序版本"
                                    optionFilterProp="children"
                                    filterOption={(input, option: any) =>
                                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
                                    {getList.general(wxMiniAppEnvVersion)}
                                </Select>
                            </Form.Item>
                        </Col>

                        <Col span={7}>
                            <Form.Item
                                label="推送类型"
                                name="remotePushTypeId"
                                tooltip='转发：服务器之间的数据发送；推送：根据规则推送数据给客人'>
                                <Select
                                    showSearch
                                    placeholder="推送类型"
                                    optionFilterProp="children"
                                    filterOption={(input, option: any) =>
                                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
                                    {getList.general(remotePushTypeData)}
                                </Select>
                            </Form.Item>
                        </Col>

                        <Col span={24}>
                            <Form.Item
                                label="欢迎词"
                                name="welcomeWords"
                                tooltip='客人进入临时会话时的欢迎词'>
                                < Input.TextArea autoSize={{ minRows: 2, maxRows: 10 }} />
                            </Form.Item>
                        </Col>

                        <Col span={4}>
                            <Form.Item
                                label="默认"
                                name="isDefault"
                                valuePropName="checked"
                                tooltip='当前客服使用者是否是默认接入（根据微信小程序及版本区分默认配置）'
                                initialValue={false}>
                                < Switch checked={false}
                                    checkedChildren="是"
                                    unCheckedChildren="否" />
                            </Form.Item>
                        </Col>

                        <Col span={6}>
                            <Form.Item
                                label="使用欢迎词"
                                name="isUseWelcomeWords"
                                tooltip='客人进入临时会话时是否发送欢迎词'
                                valuePropName="checked"
                                initialValue={false}>
                                < Switch checked={false}
                                    checkedChildren="是"
                                    unCheckedChildren="否" />
                            </Form.Item>
                        </Col>

                        <Col span={5}>
                            <Form.Item
                                label="状态"
                                name="isUse"
                                valuePropName="checked"
                                initialValue={true}>
                                < Switch checked={true}
                                    checkedChildren="启用"
                                    unCheckedChildren="关闭" />
                            </Form.Item>
                        </Col>

                    </Row>
                </Form>
            </AntDraggableModal>
        </>
    )
}

export default WebEdit;